export default __webpack_public_path__ + "static/media/Background_00050.2f303f1e.png";